// Embed
export { default as Embed } from "./Embed";
export type { default as EmbedProps } from "./EmbedProps.interface";